module.exports = __webpack_public_path__ + "img/0334-cart.a34a1037.svg";